const firebaseConfig = {
  apiKey: "AIzaSyAi-pfjSCuxd3F7jiArW0WlJiDujo-iF_o",
  projectId: "user-aa040",
  messagingSenderId: "538559574433",
  appId: "1:538559574433:web:68fc71bb83fac01c3adbe0",
  vapidKey: "BO-I5GKwLuy4sh-dc-tXs45a71B6JY47NWFT_zrhccan2v0lbMmL5eB_mS_cSlpokZvAxZM_U5GLX0s_9yZMf9M",
};

export default firebaseConfig;
